export const QA_NAME_LISTING_PROFILE_PHOTOS_WIDGET = 'listingGallery'
